import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-rhythm-gauge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rhythm-gauge.component.html',
  styleUrls: ['./rhythm-gauge.component.css']
})
export class RhythmGaugeComponent {
  @Input() description: string = '';
  @Input() pointerRotation: number = -90; 
  @Input() currentPercentage: number = 0;
}